module.exports = __webpack_public_path__ + "media/3-11.8c427bec.wav";